import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Switch } from 'antd';


const SwitchItem = (props) => {
    const { title, disabled, switch_text, switch_text_class, switch_first, seperated, name, checked, onChange, hide_switch } = props;

    return (
        <div className={classNames("ori-animated ori-fade-in ori-tb-pad-5 ori-flex-row", { "ori-flex-rr": switch_first, "ori-flex-jsb": seperated } )}>
            {
                title &&
                <p className={classNames("ori-capitalize-first ori-full-flex", { "ori-l-pad-10": switch_first })}>{title}</p>
            }
            {
                !hide_switch &&
                <div className="ori-l-pad-5">
                    <Switch name={name} size="small" disabled={disabled} checked={checked} onChange={onChange} />
                    {
                        switch_text &&
                        <span className={`ori-capitalize-first ${switch_text_class}`}>{switch_text}</span>
                    }
                </div>
            }
        </div>
    );
};

SwitchItem.propTypes = {
    title: PropTypes.string,
    switch_text: PropTypes.string,
    switch_text_class: PropTypes.string,
    seperated: PropTypes.bool,
    switch_first: PropTypes.bool,
    name: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    hide_switch: PropTypes.bool,
    disabled: PropTypes.bool,
};

SwitchItem.defaultProps = {
    seperated: false,
    switch_first: false,
    hide_switch: false,
    switch_text_class: 'ori-l-pad-5 ori-font-xs ori-font-bold ori-font-light',
    disabled: false,
};

export default SwitchItem;


// WEBPACK FOOTER //
// ./src/components/form/switchitem/index.js